export const UPDATES_CATEGORIES = [
  'ALL',
  'IMPACT',
  'LEARNING',
  'AFEX CULTURE',
  'PRESS RELEASE',
  'EVENTS',
];

export const CATEGORY_ID_MAP = {
  IMPACT: 145,
  LEARNING: 150,
  AFEX_CULTURE: 144,
  PRESS_RELEASE: 151,
  EVENTS: 152,
};
